import { Title } from '@components/styled/Title.styled';
import React from 'react';
import * as styled from './styled/TitleGroup.styled';

export const TitleGroup: React.FC<{
    Icon?: React.FunctionComponent<
        React.SVGProps<SVGSVGElement> & {
            title?: string | undefined;
        }
    >;
    title: string;
    Chip?: React.ReactNode;
}> = ({ Icon, title, Chip }) => {
    return (
        <styled.TitleGroup>
            {Icon && <Icon />}
            <Title>{title}</Title>
            {Chip}
        </styled.TitleGroup>
    );
};
